import { isPvpOnlyCard } from './cards';
import { type ModeNotice, PVP_ONLY_BADGE, pvpOnlyNotice } from './mode-notice';

/**
 * **O aviso de uma carta que só vale no duelo** (gate V28H.B).
 *
 * Separado do catálogo pela mesma razão que `jewel-mode-notice.ts` está separado
 * de `jewels.ts`: o catálogo decide onde uma carta vale, e este ficheiro decide
 * o que se ESCREVE quando ela não vale em toda a parte. São duas mudanças com
 * ritmos diferentes.
 */

/** A etiqueta, que é a mesma do inventário inteiro. */
export const CARD_PVP_ONLY_BADGE = PVP_ONLY_BADGE;

/**
 * **A explicação, por extenso.** Aprovada, e escrita uma vez.
 *
 * Diz que a carta não produz efeito na Caça. Não diz que ela é inválida, que não
 * pode ser equipada, que está desligada, ou que um dia funcionará - nenhuma
 * dessas quatro é verdade. Uma carta exclusivamente de duelo continua a poder
 * ocupar um dos três espaços; o que ela não faz é produzir efeito na caça.
 */
export const CARD_PVP_ONLY_NOTE = 'Esta carta não produz efeito na Caça.';

/**
 * O aviso de modo desta carta, ou `null` quando não há aviso a dar.
 *
 * Uma função e não um `if` na interface, porque a condição não é "é o Malware".
 * É "produz efeito no duelo e não na caça" - {@link isPvpOnlyCard} - e essa
 * pergunta é feita ao catálogo. Uma interface que comparasse ids teria uma
 * segunda lista a envelhecer ao lado da primeira.
 */
export function cardModeNotice(definitionId: string): ModeNotice | null {
  if (!isPvpOnlyCard(definitionId)) {
    return null;
  }
  return pvpOnlyNotice(CARD_PVP_ONLY_NOTE);
}
